/**
 * Entities Store State
 * Type-safe state definition for normalized entities
 */

import { EntitiesState, createEmptyRelationships } from './types';

export default function createState(): EntitiesState {
  return {
    // Normalized entities stored by ID
    homes: {},
    rooms: {},
    devices: {},
    gateways: {},

    // Relationship mappings for cross-referencing
    relationships: createEmptyRelationships(),

    // Device telemetry (Last telemetry for fast device switching)
    deviceTelemetry: {},

    // Metadata
    photoUrlByHome: {},

    // Cache control
    lastFetched: null,
    cacheVersion: '1.3', // Incremented for deviceTelemetry addition
  };
}
